module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/logo-guard.b17bd7be.png";